import type { ParamKey, TransitionType } from '@ve/core';

export const TRANSITION_LABELS: Record<TransitionType, string> = {
  crossfade: 'Cross dissolve',
  dipToBlack: 'Dip to black',
  dipToWhite: 'Dip to white',
  wipeLeft: 'Wipe left',
  wipeRight: 'Wipe right',
  wipeUp: 'Wipe up',
  wipeDown: 'Wipe down',
  slideLeft: 'Slide left',
  slideRight: 'Slide right',
  zoom: 'Zoom',
  circle: 'Iris circle',
};

export const TRANSITION_DESCRIPTIONS: Record<TransitionType, string> = {
  crossfade: 'Blends smoothly from one clip into the next',
  dipToBlack: 'Fades out to black, then in to the next clip',
  dipToWhite: 'Fades out to white, then in to the next clip',
  wipeLeft: 'A hard edge sweeps right-to-left revealing the next clip',
  wipeRight: 'A hard edge sweeps left-to-right revealing the next clip',
  wipeUp: 'A hard edge sweeps bottom-to-top revealing the next clip',
  wipeDown: 'A hard edge sweeps top-to-bottom revealing the next clip',
  slideLeft: 'The next clip pushes the current one out to the left',
  slideRight: 'The next clip pushes the current one out to the right',
  zoom: 'Zooms into the current clip and out of the next one',
  circle: 'A growing circle reveals the next clip',
};

export const PARAM_HELP: Record<ParamKey, string> = {
  x: 'Horizontal offset from the frame centre, in pixels',
  y: 'Vertical offset from the frame centre, in pixels (down is positive)',
  scale: 'Overall size relative to the fitted size',
  scaleX: 'Width relative to the fitted size',
  scaleY: 'Height relative to the fitted size',
  rotation: 'Clockwise rotation in degrees',
  opacity: 'Transparency: 0 % is invisible, 100 % fully opaque',
  volume: 'Clip loudness: 100 % is original level, up to 400 %',
  cropLeft: 'Cut away part of the left edge',
  cropRight: 'Cut away part of the right edge',
  cropTop: 'Cut away part of the top edge',
  cropBottom: 'Cut away part of the bottom edge',
};
